import React, { Component } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { connect, ConnectedProps } from 'react-redux'
import routes from '../../routes/routes'
import { RootState } from '../../store'
import { listWorkOrders } from './WorkOrderCalendar.slice'
import ContentLayout from '../../components/ContentLayout'
import ContentMain from '../../components/ContentMain'
import Card from '../../components/Card'
import CardButton from '../../components/CardButton'
import HeadingRow from '../../components/HeadingRow'
import Calendar from '../../components/WorkOrderCalendar/Calendar'
import { i18n } from "../../i18n/i18n";

interface Props extends RouteComponentProps {}

type CombinedProps = Props & ConnectedProps<typeof connector>

class WorkOrderCalendar extends Component<CombinedProps> {
  constructor (props: CombinedProps) {
    super(props)
    this.handleCreateClick = this.handleCreateClick.bind(this)
  }

  handleCreateClick () {
    this.props.history.push(routes.workOrderCreate)
  }

  componentDidMount () {
    this.props.listWorkOrders()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="full">
          <Card>
            <HeadingRow heading={i18n("Work Order Scheduler")}>
              <CardButton
                proceedText='Create'
                cancelText={i18n("Back")}
                onProceedClick={this.handleCreateClick} />
            </HeadingRow>
            <Calendar />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

const mapStateToProps = (state: RootState) => {
  const { month, year } = state.workOrderCalendar
  return { month, year }
}

const mapDispatchToProps = {
  listWorkOrders
}

const connector = connect(mapStateToProps, mapDispatchToProps)
export default connector(WorkOrderCalendar)
